import Vue from 'vue'
import Router from 'vue-router'
import WaitAuthResultPage from '@/pages/WaitAuthResult'
import LoginPage from '@/pages/LoginPage'
import ListPage from '@/pages/ListPage'
import TweetDetailPage from '@/pages/TweetDetailPage'
import StockDetailPage from '@/pages/StockDetailPage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'TopPage',
      component: LoginPage
    },
    {
      path: '/WaitAuthResult',
      name: 'WaitAuthResultPage',
      component: WaitAuthResultPage
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/myimgs',
      name: 'ListPage',
      component: ListPage,
      props: { initialListType: 'myimgs' }
    },
    {
      path: '/favs',
      name: 'FavsPage',
      component: ListPage,
      props: { initialListType: 'favs' }
    },
    {
      path: '/stocks',
      name: 'StocksPage',
      component: ListPage,
      props: { initialListType: 'stocks' }
    },
    {
      path: '/status/:id/:mindex',
      name: 'TweetDetailPage',
      component: TweetDetailPage
    },
    {
      path: '/stock/:stockid',
      name: 'StockDetailPage',
      component: StockDetailPage
    },
    {
      path: '/_stock/:stockid',
      redirect: '/stock/:stockid'
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js